import styled from "styled-components";

export const LanguageSelectList = styled("ul")`
  display: flex;
  position: relative;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;
